var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tzModal",class:{ 'tzModal--close': !_vm.open }},[_c('button',{staticClass:"tzModal__close-btn",on:{"click":function($event){$event.preventDefault();return _vm.handleCloseModal.apply(null, arguments)}}},[_vm._v("\n    X\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }